import { api } from "./api";

/** REASON-1 · 关键操作「原因」——快选项唯一真源在后端 services/reason_codes.py，前端不写死 */
export type ReasonScene =
  | "price_change" | "credit_change" | "credit_decision" | "product_unpublish" | "product_publish"
  // REASON-2
  | "inventory_adjust" | "oversell" | "capacity_override" | "order_confirm" | "hotel_suspend" | "payment_void" | "payable_decision"
  // OPENAPI-2（场景码待 OPENAPI-1 在 services/reason_codes.py 登记）
  | "openapi_reject" | "openapi_revoke"
  // OPENAPI-FIX-3 · 退回上线申请 / 停用对方推送地址（场景码以后端 services/reason_codes.py 为准）
  | "openapi_go_live_reject" | "openapi_webhook_disable"
  // SETTLE-W1 · 平台周结（核到账差额必填 / 改结算设置选填）
  | "platform_settlement_diff" | "platform_settlement_setting"
  // MANUAL-ORD-1 · 手工订单当场授权（改价 / 同行临时加额度，原因必填）
  | "manual_order_price" | "partner_temp_credit";

export interface ReasonItem {
  code: string;
  label: string;
  group: "approve" | "reject" | null;
  /** 选「其它」类代码时补充说明必填 */
  needs_text: boolean;
}

export interface ReasonCodesRead {
  scene: ReasonScene;
  required: boolean;
  text_max: number;
  items: ReasonItem[];
}

/** 提交给各写接口的原因字段（reason_code + reason 说明），和后端 Update 请求体字段同名 */
export interface ReasonPayload {
  reason_code?: string;
  reason?: string;
}

/** GET /api/v1/reason-codes?scene= */
export function getReasonCodes(scene: ReasonScene): Promise<ReasonCodesRead> {
  return api(`/api/v1/reason-codes?scene=${encodeURIComponent(scene)}`);
}
